import { useEffect, useState, useCallback } from 'react'

type SwiperCallback = () => any

interface Swiper {
  isBeginning: boolean
  isEnd: boolean
  on: (arg0: string, arg1: SwiperCallback) => any
  slidePrev: () => any
  slideNext: () => any
}

type Output = [
  {
    handlePrev: () => any
    handleNext: () => any
  },
  {
    prevDisabled: boolean
    nextDisabled: boolean
  }
]

const useSwiperPagination = (swiper: Swiper): Output => {
  const [paginationState, setPaginationState] = useState({
    prevDisabled: true,
    nextDisabled: false,
  })

  useEffect(() => {
    if (swiper) {
      // eslint-disable-next-line func-names
      ;['slideChange', 'observerUpdate'].forEach((event) =>
        swiper.on(event, () => {
          setPaginationState({
            prevDisabled: swiper.isBeginning,
            nextDisabled: swiper.isEnd,
          })
        })
      )
    }
  }, [swiper])

  const handlePrev = useCallback(() => {
    if (swiper) swiper.slidePrev()
  }, [swiper])

  const handleNext = useCallback(() => {
    if (swiper && !swiper.isEnd) swiper.slideNext()
  }, [swiper])

  return [{ handlePrev, handleNext }, paginationState]
}

export default useSwiperPagination
